import React from 'react'
import css from './style.scss'

const DiscountCodeInput = props => {
  return (
    <input
      id={props.id}
      type='text'
      className={css.discountCodeInput}
      {...props.input}
    />
  )
}

export default DiscountCodeInput
